const FETCH_CACHE_TIMEOUT = 30 * 1000;

export const hasCacheExpired = (lastFetchTime: number) =>
  lastFetchTime ? Date.now() - lastFetchTime >= FETCH_CACHE_TIMEOUT : true;
